import React, {useEffect} from 'react';
import {LoadScript, GoogleMap, Polygon, DrawingManager} from '@react-google-maps/api';

const Map = ({areas, lat, lon}) => {

  const getPolygonPath = (pointsString) => {
      console.log(pointsString);
      console.log(JSON.parse(pointsString));
    return JSON.parse(pointsString);
  };

  // const polygonProps = polygon
  //   ? {
  //     path: polygon.getPath(),
  //     editable: polygon.editable,
  //     clickable: polygon.clickable,
  //     options: {
  //       fillOpacity: polygon.fillOpacity,
  //       strokeWeight: polygon.strokeWeight,
  //     },
  //   }
  //   : null;

  return (
    <div className={ 'map' }>
      {/*<LoadScript*/}
      {/*  id="script-loader"*/}
      {/*  googleMapsApiKey={GOOGLE_API_KEY}*/}
      {/*  language="en"*/}
      {/*  libraries={['drawing']}*/}
      {/*  region="us"*/}
      {/*>*/}
        <GoogleMap
          mapContainerClassName="App-map"
          center={ { lat: lat || 32.109333, lng: lon || 34.855499 } }
          zoom={ 12 }
          version="weekly"
          on
        >
          { areas.map(pointsString => (
             <Polygon
               path={ getPolygonPath(pointsString) }
               options={ {
                 strokeColor: '#369BF7',
                 strokeWeight: 1,
                 fillColor: '#369BF7'
               } }
             />
          ) ) }

        </GoogleMap>
      {/*</LoadScript>*/}
    </div>

  );
};

export default Map;
